<icc-select-box *ngIf='mode==="basic"' [imageUrl]="'/files/awningvalance/' + selectedFrill.img" [title]="selectedFrill.name || 'Brak Falbany'" [buttonText]="'Zmień'" (select)="onFrillChange()">
</icc-select-box>
<icc-list itemImgHeight="medium" itemTemplate="itemImgTitle" (select)="selectFrill($event)" [items]='frills' *ngIf='mode==="list"'>
</icc-list>
